export const fetchVisaTypesData = `*[_type == "visaTypes"]{
  _id,
  type,
  description,
}`

export const fetchFounderData = `*[_type == "founder"][0] {
  name,
  position,
  description,
  "imageUrl": image.asset->url
}
`

export const fetchFAQData = `*[_type == "faq"] {
  _id,
  question,
  answer
}`

export const fetchResidentVisasData = `*[_type == "residentVisas"]{
  _id,
  title,
  description,
}`

export const fetchMigrantVisasData = `*[_type == "migrantVisas"]{
  _id,
  title,
  description,
}`

export const fetchHeroData = `*[_type == "hero"]{
  _id,
  heading,
}`

export const fetchTouristVisasData = `*[_type == "touristVisas"]{
  _id,
  title,
  description,
}`

export const fetchSiteConfigData = `*[_type == "siteConfig"][0]{
  instagram,
  facebook,
  whatsapp,
  calendly,
  businessName,
  phoneNumber,
  siteUrl,
  email,
  "logoUrl": siteLogo.asset->url
}`

export const fetchServicesData = `*[_type == "services"]{
  _id,
  title,
  description,
}`
